import React, { useEffect, useState } from "react";
import UploadLeadsModal from "../../components/LeadsBulkUpload/UploadLeadsModal";

const LeadsBulkUpload = (props) => {
  return <UploadLeadsModal />;
};

export default LeadsBulkUpload;
